import { FetchError } from '@lib/types/api/FetchError';
import { isTest } from '../env';

const isRelativeUrl = (url: string) => url.startsWith('/');

/**
 * @throws {FetchError}
 */
export const failingFetcher = async (
  url,
  options: RequestInit,
  rawResponse = false
) => {
  // append base url when running in test since Mock Service Worker doesn't resolve relative urls in Node environments
  const BASE_URL =
    isTest() && isRelativeUrl(url) ? 'http://localhost:3000' : '';

  const response = await fetch(BASE_URL + url, options);

  if (!response.ok) {
    try {
      const body = await response.json();
      console.error(
        `${BASE_URL + url} ${response.status} ${response.statusText}`,
        body
      );
    } catch (e) {}

    throw new FetchError(
      `${url}: ${response.status} ${response.statusText}`,
      response.status
    );
  }

  try {
    if (rawResponse) {
      return response;
    }
    const body = await response.json();
    if (body) {
      return body;
    }
  } catch (error) {
    // if there is no body to parse from backend .json() can throw JSON error
    // response still succeeded so simply return empty body
    return {};
  }

  return {};
};

export const swrFetcher = (endpoint: string, init?: RequestInit) => {
  return fetch(endpoint, init).then(async (res) => {
    if (!res.ok) {
      throw await res.json();
    }
    return res.json();
  });
};

export const swrMutationFetcher = (endpoint: string, init?: RequestInit) => {
  const { method = 'POST', headers, ...rest } = init ?? {};
  return fetch(endpoint, {
    method,
    headers: headers ?? {
      'Content-Type': 'application/json',
    },
    ...rest,
  }).then(async (res) => {
    if (!res.ok) {
      throw await res.json();
    }
    return res.json();
  });
};
